import { createFromIconfontCN } from '@ant-design/icons'

export default createFromIconfontCN({
  scriptUrl: '/iconfont.js',
})
